import { Button, Col, Row, Text } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { PaymentModal } from './components';

import { SearchUsers } from './components';

const nullPricing = {
  usd: { price: 0, fee: 20 },
  eur: { price: 0, fee: 20 },
  gbp: { price: 0, fee: 20 },
  jpy: { price: 0, fee: 20 }
};

const AthletesAndTeams = ({ setPage, athleteId, setData }) => {
  const [primary, setPrimary] = useState(null),
    [selected, setSelected] = useState([]),
    { removedSuggestions } = useSelector((state) => state.user),
    { isMobile } = useSelector((state) => state.appState),
    dispatch = useDispatch(),
    navigate = useNavigate(),
    [visible, setVisible] = useState(false),
    user = useSelector((state) => state.user),
    { cards } = user.billing || {},
    { t } = useTranslation();

  useEffect(() => {
    if (athleteId) {
      handleSelect({ _id: athleteId }, 'single', true);
    }
  }, []);

  function handleNext() {
    if (!cards?.length) {
      setVisible(true);
      return;
    }

    setData(
      selected.map((x) => ({
        user:
          x.type === 'team'
            ? {
                ...x.user,
                athletes: null
              }
            : x.user,
        type: x.type,
        pricing: x.user.type === 'team' && x.type === 'single' ? nullPricing : x.pricing,
        discounts: x.discounts,
        excludeIds: x.type === 'bundle' ? x.excludeIds : undefined
      }))
    );

    setPage('summary');
  }

  function handlePaymentModalVisible() {
    setVisible(!visible);
  }

  async function handleSelect(opt, type, isPrimary) {
    if (selected.find((x) => x.user._id === opt._id && x.type === type)) {
      return setSelected(
        selected.filter(
          (x) =>
            x.user._id !== opt._id ||
            (x.type !== type &&
              // If the team is unselected, unselect it's bundle too
              (type === 'bundle' || !x.user._id === opt._id))
        )
      );
    }

    const res = await Api.post('/subscriptions/getPricing', { userId: opt._id });
    if (!res) return;

    if (isPrimary && res.user?.type === 'team' && type === 'single')
      handleSelect(opt, 'bundle', true);

    if (type === 'bundle') res.excludeIds = [];

    if (isPrimary) setPrimary(res.user);
    // Use a callback here since this is an async setState
    setSelected((selected) => [...selected, { ...res, type }]);
  }

  return (
    <Col
      wid={isMobile ? '100vw' : '936px'} // Set width to 100vw on mobile for full width
      noFlex
      ht="inherit"
      center
      start
      pad={isMobile ? '16px' : '0'} // Add padding on mobile for better spacing
    >
      <Row marg="36px 0 0" between pad={isMobile && '0 16px'}>
        <Text h2 marg="4px 0 0" style={{ fontSize: isMobile ? '18px' : '24px' }}>
          {t('subscribe.athletesAndTeams')}
        </Text>

        <Row gap="8px">
          {!athleteId && (
            <Button
              bordered
              text={t('subscribe.remindMeLater')}
              pad="0 24px"
              wid="fit-content"
              onClick={() => navigate('/')}
            />
          )}

          <Button
            text={t('common.next')}
            wid="fit-content"
            pad="0 24px"
            onClick={() => handleNext('checkout')}
          />
        </Row>
      </Row>

      <SearchUsers
        primary={primary}
        setPrimary={setPrimary}
        selected={selected}
        setSelected={setSelected}
        handleSelect={handleSelect}
      />

      <PaymentModal
        visible={visible}
        closeModal={handlePaymentModalVisible}
        navigate={navigate}
        athleteId={athleteId}
        cta={'subscribe'}
      />
    </Col>
  );
};

export default AthletesAndTeams;
